import { RouteRecordRaw } from 'vue-router';

import { AppRouteNames, AppRoutes } from '@tallo/investor/navigation';

import BuildingNavigation from './building-navigation.vue';
import Building from './building.vue';
import BuildingTeamPage from './pages/building-team-page.vue';
import BuildingUnits from './pages/building-units.vue';
import BuildingDetails from './pages/details/building-details.vue';

/** The building page: its header above a tab row, with the open tab's page under them */
export const buildingRoutes: RouteRecordRaw = {
  path: AppRoutes.INVESTOR_BUILDING,
  name: AppRouteNames.INVESTOR_BUILDING,
  components: {
    default: Building,
    subheader: BuildingNavigation,
  },
  meta: { public: false },
  // Links to a building name the building, not a tab; they open on its units
  redirect: { name: AppRouteNames.INVESTOR_BUILDING_UNITS },
  children: [
    {
      path: AppRoutes.INVESTOR_BUILDING_UNITS,
      name: AppRouteNames.INVESTOR_BUILDING_UNITS,
      component: BuildingUnits,
    },
    {
      path: AppRoutes.INVESTOR_BUILDING_DETAILS,
      name: AppRouteNames.INVESTOR_BUILDING_DETAILS,
      component: BuildingDetails,
    },
    {
      path: AppRoutes.INVESTOR_BUILDING_TEAM,
      name: AppRouteNames.INVESTOR_BUILDING_TEAM,
      component: BuildingTeamPage,
    },
  ],
};
